import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecruitedSubject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 185",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .400391,
			width: 40,
			height: 40,
			rx: 4,
			fill: "#FEF7DF"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "person_search",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_119_12919",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 10,
				y: 10,
				width: 21,
				height: 20,
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Bounding box",
					x: 10.4004,
					y: 10,
					width: 20,
					height: 20,
					fill: "#D9D9D9"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_119_12919)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "person_search_2",
					d: "M19.5671 19.9999C18.6504 19.9999 17.8657 19.6736 17.2129 19.0208C16.5601 18.368 16.2337 17.5833 16.2337 16.6666C16.2337 15.7499 16.5601 14.9652 17.2129 14.3124C17.8657 13.6597 18.6504 13.3333 19.5671 13.3333C20.4837 13.3333 21.2684 13.6597 21.9212 14.3124C22.574 14.9652 22.9004 15.7499 22.9004 16.6666C22.9004 17.5833 22.574 18.368 21.9212 19.0208C21.2684 19.6736 20.4837 19.9999 19.5671 19.9999ZM28.8171 29.5833L26.1504 26.9166C25.8587 27.0833 25.5462 27.2222 25.2129 27.3333C24.8796 27.4444 24.5254 27.4999 24.1504 27.4999C23.1087 27.4999 22.2233 27.1354 21.4941 26.4062C20.765 25.677 20.4004 24.7916 20.4004 23.7499C20.4004 22.7083 20.765 21.8229 21.4941 21.0937C22.2233 20.3645 23.1087 19.9999 24.1504 19.9999C25.1921 19.9999 26.0775 20.3645 26.8066 21.0937C27.5358 21.8229 27.9004 22.7083 27.9004 23.7499C27.9004 24.1249 27.8448 24.4791 27.7337 24.8124C27.6226 25.1458 27.4837 25.4583 27.3171 25.7499L29.9837 28.4166L28.8171 29.5833ZM24.1504 25.8333C24.7337 25.8333 25.2268 25.6319 25.6296 25.2291C26.0323 24.8263 26.2337 24.3333 26.2337 23.7499C26.2337 23.1666 26.0323 22.6736 25.6296 22.2708C25.2268 21.868 24.7337 21.6666 24.1504 21.6666C23.5671 21.6666 23.074 21.868 22.6712 22.2708C22.2684 22.6736 22.0671 23.1666 22.0671 23.7499C22.0671 24.3333 22.2684 24.8263 22.6712 25.2291C23.074 25.6319 23.5671 25.8333 24.1504 25.8333ZM19.5879 20.8333C19.0046 21.6944 18.7129 22.6666 18.7129 23.7499C18.7129 24.8333 19.0046 25.8055 19.5879 26.6666H12.9004V24.3541C12.9004 23.8819 13.0184 23.4444 13.2546 23.0416C13.4907 22.6388 13.8171 22.3333 14.2337 22.1249C14.9421 21.7638 15.7407 21.4583 16.6296 21.2083C17.5184 20.9583 18.5046 20.8333 19.5879 20.8333Z",
					fill: "#3F3518"
				})
			})]
		})]
	})
});
export default SvgRecruitedSubject;
